import { useQueryClient } from "@tanstack/react-query";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";
import {
  type TitleJournalMutateOptions,
  withTitleJournalInvalidation,
} from "./invalidate-title-journal-queries";

interface IUseSendApproval {
  titleId: string;
}

export function useSendApproval({ titleId }: IUseSendApproval) {
  const queryClient = useQueryClient();
  const mutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/status/approve",
  );

  return {
    ...mutation,
    mutate: (mutateOptions?: TitleJournalMutateOptions) => {
      mutation.mutate(
        {
          params: { path: { titleId } },
        },
        withTitleJournalInvalidation(queryClient, titleId, mutateOptions),
      );
    },
  };
}
